import {EyeOff, Lock} from "lucide-react";
import type Combatant from "@/encounter/model/Combatant.ts";
import type {AreaEffect, AreaEffectType} from "@/encounter/model/AreaEffect.ts";
import {useAreaEffect} from "@/encounter/effect/AreaEffectHooks.ts";
import {useTableTopSelection} from "@/tabletop/selection/TableTopSelectionHooks.ts";
import {Button} from "@/components/ui/button.tsx";
import {Separator} from "@/components/ui/separator.tsx";

const TYPE_LABELS: Record<AreaEffectType, string> = {
    Rect: "Rechteck",
    Arc: "Bogen",
    Sphere: "Kreis",
};

const getEffectLabel = (effect: AreaEffect) => effect.name?.trim() || TYPE_LABELS[effect.type];

export default function CombatantAreaEffects({combatant}: { combatant: Combatant }) {
    const {effects} = useAreaEffect();
    const {selectAreaEffect} = useTableTopSelection();
    const assignedEffects = effects.filter(effect => effect.combatantId === combatant.id);

    if (assignedEffects.length === 0) return null;

    return (
        <div className="flex flex-col gap-2">
            <Separator/>
            <div className="text-sm font-semibold">Flächeneffekte</div>
            {assignedEffects.map(effect => (
                <Button
                    key={effect.id}
                    type="button"
                    variant="outline"
                    size="sm"
                    className="w-full justify-start"
                    onClick={() => selectAreaEffect(effect)}
                >
                        <span
                            className="size-3 shrink-0 rounded-full border border-white/40"
                            style={{backgroundColor: effect.color}}
                        />
                    <span className="grow truncate text-left">{getEffectLabel(effect)}</span>
                    {effect.hidden && <EyeOff className="text-muted-foreground"/>}
                    {effect.locked && <Lock className="text-violet-400"/>}
                </Button>
            ))}
        </div>
    )
}
